import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePageTitle } from '../hooks/usePageTitle';
import Card from '../components/Card';
import Button from '../components/Button';
import ReportList from '../components/ReportList';
import './AdminDashboard.css';

const AdminDashboard: React.FC = () => {
  const { user } = useAuth();
  usePageTitle('Administración');

  return (
    <div className="admin-dashboard">
      <div className="dashboard-header">
        <h1>Panel de Administración</h1>
        <p>Bienvenido al panel administrativo de MAMDP, {user?.name}.</p>
      </div>

      <div className="dashboard-content">
        {/* Weather Reports Management Section */}
        <div className="dashboard-section">
          <ReportList />
        </div>

        <div className="dashboard-grid">
          {/* Dorothy Alerts Management */}
          <Card className="dashboard-card">
            <div className="card-header">
              <h2>🚨 Alertas Dorothy</h2>
              <p>Configurar alertas meteorológicas automáticas</p>
            </div>
            <div className="card-actions">
              <Link to="/admin/dorothy/alerts">
                <Button variant="primary" size="md">
                  Gestionar Alertas
                </Button>
              </Link>
            </div>
          </Card>

          {/* Photo Management */}
          <Card className="dashboard-card">
            <div className="card-header">
              <h2>📷 Gestión de Fotos</h2>
              <p>Administrar la galería de fotos de MAMDP</p>
            </div>
            <div className="card-actions">
              <Link to="/admin/photos">
                <Button variant="primary" size="md">
                  Gestionar Fotos
                </Button>
              </Link>
            </div>
          </Card>

          {/* User Management */}
          <Card className="dashboard-card">
            <div className="card-header">
              <h2>👥 Gestión de Usuarios</h2>
              <p>Administrar usuarios y permisos del sistema</p>
            </div>
            <div className="card-actions">
              <Link to="/admin/users">
                <Button variant="primary" size="md">
                  Gestionar Usuarios
                </Button>
              </Link>
            </div>
          </Card>

          {/* Quick Stats */}
          <Card className="dashboard-card stats-card">
            <div className="card-header">
              <h2>📊 Estadísticas Rápidas</h2>
            </div>
            <div className="stats-grid">
              <div className="stat-item">
                <span className="stat-label">Informes Publicados</span>
                <span className="stat-value">-</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Usuarios Activos</span>
                <span className="stat-value">-</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Última Actividad</span>
                <span className="stat-value">-</span>
              </div>
            </div>
            <p className="stats-note">
              <em>Las estadísticas se implementarán en futuras versiones</em>
            </p>
          </Card>

          {/* Quick Actions */}
          <Card className="dashboard-card">
            <div className="card-header">
              <h2>⚡ Acciones Rápidas</h2>
            </div>
            <div className="quick-actions">
              <Link to="/admin/reports" className="quick-action-link">
                <div className="quick-action">
                  <span className="action-icon">📝</span>
                  <span className="action-text">Nuevo Informe</span>
                </div>
              </Link>
              <Link to="/admin/photos" className="quick-action-link">
                <div className="quick-action">
                  <span className="action-icon">📷</span>
                  <span className="action-text">Subir Foto</span>
                </div>
              </Link>
              <Link to="/admin/users" className="quick-action-link">
                <div className="quick-action">
                  <span className="action-icon">👤</span>
                  <span className="action-text">Nuevo Usuario</span>
                </div>
              </Link>
              <Link to="/" className="quick-action-link">
                <div className="quick-action">
                  <span className="action-icon">🏠</span>
                  <span className="action-text">Ver Sitio Público</span>
                </div>
              </Link>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;